import { Checkbox, Form } from 'antd'
import type { CheckboxChangeEvent } from 'antd/es/checkbox'
import { t } from 'i18next'
import type { ReactElement } from 'react'

export const KpiFormSheetFieldsFormAddDimeisions = ({
  checked,
  setChecked,
}: {
  checked: boolean | undefined
  setChecked: (checked: boolean) => void
}): ReactElement => (
  <div>
    <Form.Item className="mt-2" label={t(`ユーザー•グループの分析軸を自動表示`)}>
      <Checkbox
        checked={checked === true}
        value={checked === true}
        onChange={(value: CheckboxChangeEvent) => {
          setChecked(value.target.checked)
        }}
      />
    </Form.Item>
  </div>
)
